// Abort controllers are non-serializable and kept out of the store, keyed by attachment id.
const controllers = new Map<string, AbortController>();

/** Create and register an abort controller for an in-flight upload. */
export const registerAbortController = (attachmentId: string): AbortController => {
  controllers.get(attachmentId)?.abort();
  const controller = new AbortController();
  controllers.set(attachmentId, controller);
  return controller;
};

/** Abort an in-flight upload if one exists. */
export const abortUpload = (attachmentId: string): void => {
  controllers.get(attachmentId)?.abort();
  controllers.delete(attachmentId);
};

/** Drop the controller reference once an upload settles. */
export const clearAbortController = (attachmentId: string): void => {
  controllers.delete(attachmentId);
};
